import React from "react";
import SolidButton from "../SolidButton/SolidButton";
import BorderButton from "./../BorderButton/BorderButton";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

const Project = ({
  project,
  project: { _id, images, title, description, liveSite, bulletPoints },
}) => {
  const navigate = useNavigate();

  // const handleClick = () => {
  //   console.log(_id)
  //   navigate(`/project/${_id}`);
  // };
  return (
    <article className="bg-black bg-opacity-20  font-medium text-cyan-500 p-3 rounded-xl group hover:bg-opacity-40 flex flex-col">
      <div className="overflow-hidden rounded-lg">
        <img src={images[0].image} className="" alt="" />
      </div>
      <div className="mt-3 flex flex-col flex-1">
        <h3 className="text-lg md:text-xl text-gray-100 mb-2 px-2 group-hover:text-cyan-300">
          {title}
        </h3>
        <p className="text-xs md:text-sm font-normal text-gray-400 mb-1 px-2">
          {description}
        </p>
        <div className="font-normal text-gray-400 mb-5 px-2 flex-1">
          <ul className="">
            {bulletPoints.slice(0, 2).map((bp, i) => (
              <li
                key={i}
                className="grid grid-cols-[10px,1fr] gap-2 items-start"
              >
                <CheckCircleIcon className="w-3 h-3 mt-1 text-cyan-500" />
                <span className="text-xs md:text-sm ">{bp}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex gap-2">
          <SolidButton
            href={liveSite}
            className="text-sm mr-auto"
            target="_blank"
            rel="noreferrer"
          >
            Live Site
          </SolidButton>
          {/* <BorderButton href={client} className="text-sm" target="_blank" rel="noreferrer">
            Client Repo
          </BorderButton>
          <BorderButton href={server} className="text-sm" target="_blank" rel="noreferrer">
            Server Repo
          </BorderButton> */}
          <Link
            to={`/project/${_id}`}
            className="border border-cyan-300 py-1 md:py-2 px-3 md:px-5 rounded-lg hover:bg-gray-900 text-sm"
            state={{ project: project }}
          >
            View Details
          </Link>
        </div>
      </div>
    </article>
  );
};

export default Project;
